import { render, staticRenderFns } from "./DealsFields.vue?vue&type=template&id=950a0fd4&"
import script from "./DealsFields.vue?vue&type=script&lang=js&"
export * from "./DealsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports